module.exports = __webpack_public_path__ + "img/logo-3.57af9d1a.jpg";